






























































































































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { validationMixin } from 'vuelidate';
import { required, email, maxLength } from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import { MedTransGoConstants } from '../../util/constants';
import { ToastEvent } from '../../types/event';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
import { HealthcareProvider, OrgLocation } from '../../types/entity';
import { ApiRequest } from '@/types/request';
import { UploadFileResponse } from '@/types/response';
declare var google: any;

@Component({
    mixins: [validationMixin],
    data() {
        return {
            fullName: '',
            email: '',
            phone: '',
            address: {
                fullAddress: '',
                city: '',
                state: '',
                zip: '',
                landmark: '',
            },
            dropOffInstruction: '',
            dropoffInstructionImageResourceId: '',
            pickupInstruction: '',
            pickupInstructionImageResourceId: '',
            billingLocationId: '',
            imgUploading: false,
            pickupInstructionImageUrl: '',
            dropoffInstructionImageUrl: '',
            pickupImgUploading: false,
            dropoffImgUploading: false,
            isFacilityHaveCoordinates: false,
            facilityAddressLatitude: null,
            facilityAddressLongitude: null,
        };
    },
    validations() {
        const validations = {
            pickupInstruction: {
                maxLength: maxLength(100),
            },
            dropOffInstruction: {
                maxLength: maxLength(100),
            },
            fullName: {
                required,
            },
            email: {
                email,
            },
            phone: {
                regex: (phone: any) => MedTransGoConstants.PHONE_REGX.test(phone),
                required,
            },
            billingLocationId: {
                required,
            },
            address: {
                fullAddress: {
                    required,
                },
                state: {
                    required,
                },
                city: {
                    required,
                },
                zip: {
                    required,
                },
            },
            facilityAddressLatitude: {
                required,
            },
            facilityAddressLongitude: {
                required,
            },
        };
        if (this.$data.phone === '') {
            delete validations.phone.regex;
        }
        if (!this.$data.isFacilityHaveCoordinates) {
            delete validations.facilityAddressLatitude;
            delete validations.facilityAddressLongitude;
        }
        return validations;
    },
})
export default class AddHealthcareProviderModal extends Vue {
    private show = true;
    private providerGoogleAddress: any;
    private billingLocations: OrgLocation[] = [];

    public mounted() {
        this.getGoogleAddress();
        this.getBillingLocations();
    }

    private async getGoogleAddress() {
        this.$root.$on('bv::modal::shown', (bvEvent: any, modalId: any) => {
            this.providerGoogleAddress = new google.maps.places.Autocomplete(
                document.getElementById('providerAddress1'), {
                types: ['geocode'],
            },
            );
            this.providerGoogleAddress.addListener('place_changed', () => {
                this.$data.address = MapUtils.parseGoogleAddress(
                    this.providerGoogleAddress,
                );
            });
        });
    }
    /**
     * @author <Shraddha.K>
     * @description - add new provider
     * @param req {Request} - calls add provider API
     * @param res {Response} - Express Response - success result
     * @returns provider list
     * @throws InvalidRequestException if provider already exists
     */
    private async addProvider() {
        const addProviderRequest: HealthcareProvider = {
            fullname: this.$data.fullName,
            email: this.$data.email,
            phone: this.$data.phone,
            address: this.$data.address,
            dropOffInstruction: this.$data.dropOffInstruction,
            pickupInstruction: this.$data.pickupInstruction,
            pickupInstructionImageResourceId: this.$data.pickupInstructionImageResourceId,
            dropoffInstructionImageResourceId: this.$data.dropoffInstructionImageResourceId,
        };
        if (this.$data.billingLocationId) {
            addProviderRequest.billingLocationId = this.$data.billingLocationId;
        }
        const response = await ObjectFactory.getProviderService().addProvider(this.$store.state.serverUrl,
            addProviderRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_ADD_PROVIDER'),
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }

    private async phoneNumberMask() {
        const replaceInput = this.$data.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.$data.phone = !replaceInput[2] ? replaceInput[1] :
            replaceInput[1] + '-' + replaceInput[2] + (replaceInput[3] ? '-' + replaceInput[3] : '');
    }

    private close() {
        this.$emit('close');
    }

    private async getBillingLocations(): Promise<OrgLocation[]> {
        const response = await ObjectFactory.getOrganizationService().getLocations(this.$store.state.serverUrl);
        if (response.success && response.data) {
            response.data.sort((a, b) => (a.locationName || '').localeCompare(b.locationName || ''));
            this.billingLocations = response.data;
            return response.data;
        }
        return [];
    }

    private async uploadImage(type: string) {
        const fileInput = type === 'pickup' ? this.$refs.facilityPickupInstructionImgInput as HTMLInputElement
            : this.$refs.facilityDropoffIntructionImgInput as HTMLInputElement;
        this.$data.pickupImgUploading = type === 'pickup' ? true : false;
        this.$data.dropoffImgUploading = type === 'dropoff' ? true : false;
        if (fileInput && fileInput.files) {
            const file = fileInput.files[0];
            if (file) {
                const allowedExtensions = ['.jpg', '.jpeg', '.png'];
                const fileExtension = file.name.slice(Math.max(file.name.lastIndexOf('.') - 1, 0) + 2);
                if (allowedExtensions.includes('.' + fileExtension.toLowerCase())) {
                    const formData = new FormData();
                    formData.append('file', file);
                    try {
                        const iHttpService = ObjectFactory.getHttpService();
                        const apiRequest: ApiRequest = {
                            baseURL: this.$store.state.serverUrl,
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}`,
                            data: formData,
                        };

                        const response = await iHttpService.post < UploadFileResponse > (apiRequest);
                        if (response.success && response.data) {
                            if (type === 'pickup') {
                                this.$data.pickupInstructionImageResourceId = response.data.fileName;
                            }
                            if (type === 'dropoff') {
                                this.$data.dropoffInstructionImageResourceId = response.data.fileName;
                            }
                            const toastEvent: ToastEvent = {
                                message: 'Image Uploaded Successfully',
                                title: 'Success',
                                varient: 'success',
                                timeout: 5000,
                            };
                            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                        }
                    } catch (error) {
                        const toastEvent: ToastEvent = {
                            message: 'Error while uploading Image',
                            title: 'Error',
                            varient: 'danger',
                            timeout: 5000,
                        };
                        EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                    }
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        if (e.target && e.target.result) {
                            if (type === 'pickup') {
                                this.$data.pickupImgUploading = false;
                                this.$data.pickupInstructionImageUrl = e.target.result as string;
                            } else if (type === 'dropoff') {
                                this.$data.dropoffImgUploading = false;
                                this.$data.dropoffInstructionImageUrl = e.target.result as string;
                            }
                        }
                    };
                    reader.readAsDataURL(file);
                } else {
                    this.$data.pickupImgUploading = false;
                    this.$data.dropoffImgUploading = false;
                    const toastEvent: ToastEvent = {
                        message: 'Enter Valid Picture',
                        title: 'Error',
                        varient: 'danger',
                        timeout: 5000,
                    };
                    EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                }
            }
        }
    }

    private async removeImage(type: string) {
        let resourceId = '';
        if (type === 'pickup') {
            resourceId = this.$data.pickupInstructionImageResourceId;
            this.$data.pickupInstructionImageResourceId = null;
            this.$data.pickupInstructionImageUrl = null;
        }
        if (type === 'dropoff') {
            resourceId = this.$data.dropoffInstructionImageResourceId;
            this.$data.dropoffInstructionImageResourceId = null;
            this.$data.dropoffInstructionImageUrl = null;
        }
        const response = await ObjectFactory.getFileService().
            deleteFile(resourceId, this.$store.state.serverUrl);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'Image Removed Successfully',
                title: 'Success',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
            const toastEvent: ToastEvent = {
                message: 'Error While Deleting Image.',
                title: 'Error',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        }
    }

    private async onFacilityLatLngChanged() {
        if (this.$data.facilityAddressLatitude && this.$data.facilityAddressLongitude) {
            const lat = this.$data.facilityAddressLatitude;
            const lang = this.$data.facilityAddressLongitude;
            this.$data.address =
                await MapUtils.getAddressByCoordinates(lat, lang);
        }
    }
}
